module.exports = __webpack_public_path__ + "img/LEAD_GENERATION.595ce63f.svg";